import { useEffect } from 'react';
import Icon from 'core/assets/icons';

const RecipeSuggestionItemLoadingSpin = () => {
  useEffect(() => {
    (window as any).scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  }, []);

  return (
    <div className="w-full flex justify-center mb-3">
      <img
        src={Icon.RecipeAiLoadingSpin}
        alt="loading"
        width="32"
        height="32"
      />
    </div>
  )
}

export default RecipeSuggestionItemLoadingSpin
